<template>
  <v-list dense>
    <v-list-item>
      <v-list-item-avatar
        v-if="comment.user.avatar && comment.user.avatar.url != null"
      >
        <img class="p-accountBlock__icon" :src="comment.user.avatar.url" />
      </v-list-item-avatar>
      <v-list-item-avatar v-else>
        <v-icon class="p-accountBlock__icon" color="grey"> mdi-account </v-icon>
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title>{{ comment.user.name }}</v-list-item-title>
        <v-list-item-subtitle>
          <span class="p-accountBlock__datetime">{{
            comment.createdAt | moment
          }}</span>
        </v-list-item-subtitle>
      </v-list-item-content>
      <v-menu v-if="comment.user.id == currentUser.id" bottom left>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" class="mb-4" v-on="on">
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </template>
        <v-list style="background: #f5f5f5">
          <v-list-item style="display: block">
            <v-row>
              <v-btn text @click="openEditForm">編集</v-btn>
            </v-row>
            <v-row>
              <v-btn text @click="dialog = true">削除</v-btn>
            </v-row>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-list-item>
    <div
      v-if="!isEditing"
      class="p-commentBlock__content body-2 px-5"
      :class="{ 'p-commentBlock__updated': isUpdated() }"
      v-text="comment.content"
    />
    <div v-else class="caption">
      <v-form ref="commentForm" class="px-4 comment-form">
        <v-textarea
          v-model="editingContentText"
          outlined
          auto-grow
          rows="3"
          class="body-2 label-size caption"
          :rules="contentRules"
          label="コメントを入力してください"
        />
      </v-form>
      <v-card-actions class="button">
        <v-spacer></v-spacer>
        <v-btn text type="button" @click="cancelUpdateItemComment">
          キャンセル
        </v-btn>
        <v-btn text color="success" type="submit" @click="updateItemComment">
          変更を保存する
        </v-btn>
      </v-card-actions>
    </div>
    <v-dialog v-model="dialog" width="300">
      <v-card>
        <v-card-title> コメントの削除 </v-card-title>
        <v-card-text> コメントを削除しますか？ </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="dialog = false">
            キャンセル
          </v-btn>
          <v-btn color="green darken-1" text @click="deleteItemComment">
            削除
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-list>
</template>

<script>
import moment from 'moment'
import { mapState } from 'vuex'

export default {
  filters: {
    moment: function (date) {
      return moment(date).format('YYYY年M月D日 HH時mm分')
    }
  },
  props: {
    item: {
      type: Object,
      required: true
    },
    comment: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      dialog: false,
      isEditing: false,
      editingContentText: this.comment.content,
      contentRules: [(value) => !!value || 'コメントを入力してください']
    }
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.UserStore.currentUser
    })
  },
  methods: {
    deleteItemComment () {
      this.$store.dispatch('PostEditor/deleteItemComment', {
        item: this.item,
        itemComment: this.comment
      })
      this.dialog = false
      this.isEditing = false
    },
    updateItemComment () {
      if (!this.$refs.commentForm.validate()) return false

      this.$store.dispatch('PostEditor/updateItemComment', {
        itemCommentContent: this.editingContentText,
        item: this.item,
        itemCommentId: this.comment.id
      })
      this.isEditing = false
    },
    cancelUpdateItemComment () {
      this.isEditing = false
    },
    isUpdated () {
      return this.comment.createdAt !== this.comment.updatedAt
    },
    openEditForm () {
      this.editingContentText = this.comment.content
      this.isEditing = true
    }
  }
}
</script>

<style scoped lang="sass">
.p-accountBlock
  vertical-align: middle
  &__icon
    display: block
    border: 2px solid #D3D3D3
    border-radius: 50%
  &__datetime
    font-size: 0.6rem
.p-commentBlock
  &__content
    white-space: pre-wrap
  &__updated::after
    content: '（編集済み）'
    color: #6d6d6d
    font-size: 0.75rem
</style>
